import { Theme } from "../../../../../components/constants";

export default {
    uploadScreenContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        marginTop: "20px",
    },
    textAreaCustomStyles: {
        marginTop: "30px",
    },
    correctedCheckboxDiv:{
        marginTop: "20px",
    },
    noteTextContainer: {
        marginTop: "20px",
        border: `1px dashed ${Theme.TEXT_PRIMARY}`,
        padding: "10px",
    },
    noteIcon: {
        marginRight: "5px",
    },
    noteTextBold: {
        color: Theme.TEXT_PRIMARY_BLACK,
    },
    mainButtonsContainer: {
        marginTop: "20px",
        display: "flex",
        flexDirection: "row",
        gap: "20px",
    },
    nextButtonStyles: {
        padding: "5px 20px",
    },
    txtFileFormatNoticeText: {
        paddingRight: "30px",
    },
    uploadContainerBodyCustomStyles: {
        minHeight: "auto",
        padding: "25px 0px",
    },
}